import theme from 'src/theme';

export const contactSupportSx = {
    subtitle: {
        fontSize: '0.85rem',
        color: theme.palette.neutral[500],
        mb: 2,
    },
    contactsRow: {
        display: 'flex',
        flexDirection: 'column' as const,
        gap: 1,
        mb: 2.5,
    },
    contactItem: {
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        px: 1.5,
        py: 1.25,
        borderRadius: '10px',
        border: '1px solid rgba(0, 0, 0, 0.06)',
        bgcolor: '#FAFBFD',
        textDecoration: 'none',
        transition: 'all 0.15s ease',
        '&:hover': {
            borderColor: theme.palette.primary.main,
            bgcolor: 'rgba(0, 127, 220, 0.05)',
        },
    },
    contactIcon: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 32,
        height: 32,
        borderRadius: '8px',
        bgcolor: 'rgba(0, 127, 220, 0.1)',
        color: theme.palette.primary.main,
        flexShrink: 0,
        '& svg': {fontSize: 18},
    },
    contactContent: {
        display: 'flex',
        flexDirection: 'column' as const,
        gap: 0.25,
        minWidth: 0,
    },
    contactLabel: {
        fontSize: '0.65rem',
        fontWeight: 700,
        color: theme.palette.neutral[400],
        textTransform: 'uppercase' as const,
        letterSpacing: '0.06em',
        lineHeight: 1,
    },
    contactValue: {
        fontSize: '0.88rem',
        fontWeight: 600,
        color: theme.palette.neutral[800],
        lineHeight: 1.3,
    },
    divider: {
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        my: 1.5,
        '&::before, &::after': {
            content: '""',
            flex: 1,
            height: '1px',
            bgcolor: 'rgba(0, 0, 0, 0.06)',
        },
    },
    dividerLabel: {
        fontSize: '0.7rem',
        fontWeight: 600,
        color: theme.palette.neutral[400],
        textTransform: 'uppercase' as const,
        letterSpacing: '0.06em',
    },
};